import { Checkbox, Select } from 'antd';
import React, { useEffect, useState } from 'react';

type LeaveProfileTabs2Props = {
  addData?: (data) => void;
  data?: any;
  absenceTypes?: any;
  absenceTypes1?: any;
  checked?: boolean;
  addAbsenceTypesById?: (idToAdd, id) => void;
  deleteAbsenceTypesById?: (id) => void;
};

const LeaveProfileTabs2 = ({
  addData,
  data,
  absenceTypes,
  checked,
  absenceTypes1,
  addAbsenceTypesById,
  deleteAbsenceTypesById
}: LeaveProfileTabs2Props) => {
  const [state, setState] = useState({
    newAbsenceTypes: {
      absence_type_id: -1,
      is_active: true,
      priority: 0
    },
    checkLength: false,

  });
  const { newAbsenceTypes, checkLength, } = state;

  // const [absenceTypes1, setAbsenceTypes1] = useState([]);
  const add = () => {
    if (data?.absence_types?.length < absenceTypes.length) {
      addData({
        absence_types: [...data?.absence_types, newAbsenceTypes],
      });
      setState((pre) => ({
        ...pre,
        checkLength: true,
      }));
    }
  };

  const deleted = (id: number) => {
    const t = data?.absence_types.filter((o: any, i: number) => i !== id);
    const t1 = t?.map(
      (o: any, p: number) => {
        if (p >= id) {

          return {
            ...o,
            priority: p,
          };
        } else {
          return {
            ...o,
          };
        }
      },
    );
    if (t.length <= 1) {
      setState((pre) => ({
        ...pre,
        checkLength: false,
      }));
    } else {
      setState((pre) => ({
        ...pre,
        checkLength: true,
      }));
    }
    deleteAbsenceTypesById(id);
    addData(Object.assign(data, { absence_types: t1 }));
  };
  // const handleArrowUp = (id: number) => {

  //   if (id > 0) {
  //     const newArray = [...data?.absence_types];

  //     const temp = newArray[id];
  //     newArray[id] = newArray[id - 1];
  //     newArray[id - 1] = temp;

  //     addData({
  //       absence_types: newArray,
  //     });
  //    
  //   }
  // }



  // console.log(data);


  return (
    <div>
      <div style={{ marginTop: '90px' }}>
        <section className={'function_container'}>
          <div
            style={{ background: 'white', padding: 0 }}
            className={'function_wrapper'}
          >
            <div>
              <div
                style={{
                  display: 'flex',
                  borderBottom: '0.5px solid #73A1E7',
                  paddingTop: '10px',
                  paddingBottom: '10px',
                  height: 70,
                }}
              >
                <div
                  style={{
                    width: '6%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 600
                  }}
                  className='staff_leave_type_text'
                >
                  Active
                </div>
                <div
                  style={{
                    width: '30%',
                    display: 'flex',
                    alignItems: 'center',
                    marginLeft: '10px',
                    fontWeight: 600
                  }}
                  className='staff_leave_type_text'
                >
                  Type
                </div>
              </div>
            </div>
            {data?.absence_types.map((item, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '100%',
                  borderBottom: '0.5px solid #73A1E7',
                  height: 70,
                  // paddingBottom: 10,
                }}
              >
                <div
                  style={{
                    width: '6%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Checkbox checked />
                </div>
                <div className="select-container" style={{ marginLeft: 10 }} >
                  <Select
                    value={item.absence_type_id === -1 ? '' : item.absence_type_id.toString()}
                    disabled={!checked}
                    style={{ color: '#000000', width: '100%', }}
                    onChange={(value) => {
                      const t = data?.absence_types.map((o: any, p: number) => {
                        if (p === index) {
                          return {
                            ...o,
                            absence_type_id: parseInt(value),
                            priority: index,
                          };
                        } else {
                          return {
                            ...o,
                          };
                        }
                      });

                      addAbsenceTypesById(parseInt(value), index);
                      addData(Object.assign(data, { absence_types: t }));
                    }}
                    suffixIcon={
                      <img
                        src="/icons/arrow_select.svg"
                        alt="arrow"
                        className="mb-1 mr-1"
                        style={{ marginTop: 5 }}
                      />
                    }
                  >
                    <Select.Option key={-1} value="" disabled hidden> {null}</Select.Option>
                    {absenceTypes?.map((item, index) => (
                      <Select.Option
                        key={index}
                        value={item.id.toString()}
                        disabled={absenceTypes1?.includes(item.id)}
                      >
                        {item.name}
                      </Select.Option>
                    ))}
                  </Select>

                </div>
                {checked && (
                  <div style={{ display: 'flex', gap: 20, marginLeft: '35%' }}>
                    <img
                      onClick={() => {
                        add();
                      }}
                      style={{ cursor: 'pointer' }}
                      src="/icons/carbon_add-filled.svg"
                      alt="add"
                    />
                    {checkLength && (<img
                      onClick={() => {
                        deleted(index);
                      }}

                      style={{ cursor: 'pointer', color: '#407FDD' }}
                      src="/icons/carbon_close-filled.svg"
                      alt="delete"
                    />)}
                    {/* <img
                      onClick={() => {
                        handleArrowUp(index);
                      }}
                      style={{ cursor: 'pointer' }}
                      src="/icons/icon_arrow_up.svg"
                      alt="up"
                    />
                    <img
                      onClick={() => {
                        add();
                      }}
                      style={{ cursor: 'pointer' }}
                      src="/icons/icon_arrow_down.svg"
                      alt="down"
                    /> */}
                  </div>
                )}
              </div>
            ))}
            <div style={{ height: 50 }} />
          </div>
        </section>
      </div>
    </div>
  );
};


export default LeaveProfileTabs2;
